import React from 'react'
import { useTranslation } from 'react-i18next'

import Chip from '@mui/material/Chip'

import { ProfileColor, ProfileTypeString } from '../../types/enums/profileType'
import { Profile } from '../../types/profile'

interface ProfileTypeChipProps {
  profile: Profile
}

const ProfileTypeChip = (props: ProfileTypeChipProps): JSX.Element => {
  const { t } = useTranslation()

  const chipProps = props.profile.is_bbp_profile
    ? {
        color: 'bbp' as 'bbp',
        label: t('profilesview.bbp'),
      }
    : {
        color: ProfileColor[props.profile.profile_type],
        label: t(ProfileTypeString[props.profile.profile_type]),
      }

  return <Chip size="small" sx={{ fontSize: '12.5px' }} {...chipProps} />
}

export default ProfileTypeChip
